import { render, staticRenderFns } from "./nearAccidentVendor.vue?vue&type=template&id=1df96bb5"
import script from "./nearAccidentVendor.vue?vue&type=script&lang=js"
export * from "./nearAccidentVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df96bb5')) {
      api.createRecord('1df96bb5', component.options)
    } else {
      api.reload('1df96bb5', component.options)
    }
    module.hot.accept("./nearAccidentVendor.vue?vue&type=template&id=1df96bb5", function () {
      api.rerender('1df96bb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearAccidentVendor.vue"
export default component.exports